import { injectIntl } from 'react-intl';

import WriteOffPayment from './WriteOffPayment';

export default injectIntl(WriteOffPayment);
